<template>
    <div>
        <HeaderComponent></HeaderComponent>
        <ProjectsComponent></ProjectsComponent>
        <!-- <ThankComponent></ThankComponent> -->
        <AchievementsComponent></AchievementsComponent>
        <!-- <GrantsComponent></GrantsComponent> -->
        <PartnersComponent></PartnersComponent>
    </div>
</template>

<script>

import HeaderComponent from '@/components/WelcomePage/HeaderComponent'
import ProjectsComponent from '@/components/WelcomePage/ProjectsComponent'
import AchievementsComponent from '@/components/WelcomePage/AchievementsComponent'
import PartnersComponent from '@/components/WelcomePage/PartnersComponent'
// import GrantsComponent  from '@/components/WelcomePage/GrantsComponent'
// import ThankComponent from '@/components/WelcomePage/ThankComponent'

export default {
    name: 'Home',
    components: {
        HeaderComponent,
        ProjectsComponent,
        // ThankComponent,
        AchievementsComponent,
        PartnersComponent,
        // GrantsComponent
    }
}
</script>
